<div class="modal-header">
	<h5 class="modal-title" [innerHTML]="model?.heading"></h5>

	<button type="button" class="btn-close" (click)="onCancel()" aria-label="Close"></button>
</div>

<div class="modal-body">
	<div class="form-group" [innerHTML]="model?.message">
	</div>
</div>

<div class="modal-footer">
	<button type="button" class="btn" [ngClass]="'btn-' + this.model.cancel.type" (click)="onCancel()">
		{{ this.model.cancel.text }}
	</button>

	<button type="submit" class="btn" [ngClass]="'btn-' + this.model.submit.type" (click)="onSubmit()">
		{{ this.model.submit.text }}
	</button>
</div>
